import { FormField } from '@zillow/constellation';
import styled from 'styled-components';

export const FlexGrowFormField = styled(FormField)`
  flex-grow: 1;
`;
